module.exports = __webpack_public_path__ + "img/territorio-monitorado.023f0952.svg";